
if (!window.location.pathname.includes("/app")) {
  window.history.replaceState(
    '',
    '',
    "/app" + window.location.pathname
  );
}